<div class="vitals" *ngIf="vitals$ | async as v" [class.vitals--dead]="!v.alive">
    <div class="vitals__scrim"></div>

    <svg class="vitals__plot" [attr.viewBox]="viewBox" preserveAspectRatio="none" aria-hidden="true">

        <line *ngFor="let x of v.ticks" class="vitals__tick" [attr.x1]="x" [attr.x2]="x" [attr.y1]="0" [attr.y2]="H"
            vector-effect="non-scaling-stroke" />

        <line class="vitals__threshold" [attr.x1]="0" [attr.x2]="W" [attr.y1]="thresholdY" [attr.y2]="thresholdY"
            vector-effect="non-scaling-stroke" />

        <polyline *ngFor="let t of v.traces" class="vitals__trace" [attr.points]="t.points" [attr.stroke]="t.colour"
            vector-effect="non-scaling-stroke" />

        <circle *ngFor="let t of v.traces" class="vitals__head" [class.vitals__head--stopped]="!v.alive"
            [attr.cx]="t.last?.x" [attr.cy]="t.last?.y" [attr.fill]="t.colour" vector-effect="non-scaling-stroke" />
    </svg>

    <div class="vitals__readout">
        <!-- <span class="vitals__name">{{ v.name }}</span> -->

        <ng-container *ngIf="v.alive; else epitaph">
            <span class="vitals__value" *ngFor="let t of v.traces" [style.color]="t.colour">
                {{ t.key }} {{ t.current | number: '1.2-2' }}
            </span>
            <span class="vitals__note" *ngIf="v.resting">resting</span>
            <span class="vitals__note vitals__note--warn" *ngIf="v.critical && !v.resting">failing</span>
            <span class="vitals__note">{{ v.thought }}</span>
        </ng-container>

        <ng-template #epitaph>
            <span class="vitals__note">died of {{ v.causeOfDeath || 'unknown causes' }}</span>
        </ng-template>

        <span class="vitals__span">{{ v.spanHours | number: '1.0-0' }}h</span>
    </div>

    <p class="vitals__empty" *ngIf="v.empty">No readings yet. The first tick writes one.</p>
</div>